// Vite built-in constants
// See: https://vite.dev/guide/env-and-mode.html#built-in-constants
export const isTest = import.meta.env.MODE === 'test'
export const NUXT_PROXY_PREFIX = '/api' // keep in sync with /server/api route from nuxt
export const NUXT_PROXY_GOTENBERG_PREFIX = '/api/gotenberg' // keep in sync with /server/api route from nuxt
export const SocketIoPath = `/ws/socket.io`

export enum GetParametersEnum {
  IMPORT = 'import',
}

export enum BaseColorPalette {
  CYAN = '#1ABC9C',
  GREEN = '#2ECC71',
  BLUE = '#3498DB',
  PURPLE = '#9B59B6',
  MUSTARD = '#F1C40F',
  ORANGE = '#E67E22',
  GREY = '#6f6f6f',
  RED = '#ed143d',
}

export enum PremisesColorPalette {
  PURPLE_DARK = '#800080',
  RED = '#FF0000',
}
export const GotenbergIgnoreClass = 'gotenberg-ignore'
